export class CharacterItem
{
    constructor(
        public id: CharacterItemId,
        public type: CharacterItemType,
        public allowedIdsToBeVisible: Array<CharacterItemId>,
        public src: string,
        public hidden: boolean = false
    ) { }
}

export enum CharacterItemId
{
    Bucket = "bucket",
    HandMicrophone = "handMicrophone",
    HandMaraca = "handMaraca",
    FaceGreenGlasses = "faceGreenGlasses",
    // Wellies = "wellies",
    BlueHat = "blueHat",
    BrownHat = "brownHat",
    LongHat = "hatLong",
    FlowerHat = "hatFlower",
    TopHat = "hatTophat",
    HatGreenEyes = "hatGreenEyes",
    HatHearts = "hatHearts",
    Crown = "crown",
    Snorkel = "faceSnorkel",
    HeartGlasses = "faceHeartGlasses",
    GradientGlasses = "faceGradientGlasses",
    HandGreenBaloon = "handGreenBaloon",
    HandRedBaloon = "handRedBaloon",
    BodyBadge = "bodyBadge",
    HandFlag = "handFlag",
    handIceCream = "handIceCream",
    BaseHand = "baseHand",
}

export enum CharacterItemType
{
    HandHeld,
    Body,
    Face,
    Head,
}
